import React from 'react';
import {Theme, Typography} from '@mui/material';
import {SxProps} from "@mui/system";

export const BodyText: React.FC<IPWMTypographyProps> = (props) => {
  const {children, ...rest} = props;
  return (
    <Typography variant="body1" {...rest}>
      {children}
    </Typography>
    )
};

export const SubHeaderText: React.FC<IPWMTypographyProps> = (props) => {
  const {children, ...rest} = props;
  return (
    <Typography variant="h3" {...rest}>{children}</Typography>
  )
}

export const PageHeaderText: React.FC<IPWMTypographyProps> = (props) => {
  const {children, ...rest} = props;
  return (
    <Typography variant="h4" {...rest}>{children}</Typography>
  )
}
export const PageEmphasisText: React.FC<IPWMTypographyProps> = (props) => {
  const {children, ...rest} = props;
  return (
    <Typography variant="h6" {...rest}>{children}</Typography>
  )
}

export const BodyHeading: React.FC<IPWMTypographyProps> = (props) => {
  const {children, ...rest} = props;
  return (
    <Typography variant="h5" {...rest}>{children}</Typography>
  )
}

export const SubText: React.FC<IPWMTypographyProps> = (props) => {
  const {children, ...rest} = props;
  return (
    <Typography color="text.secondary" variant="body2" {...rest}>
      {children}
    </Typography>
  )
}

interface IPWMTypographyProps {
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
}